import { ListTaskIcon, PlanetIcon } from '@App/static/icons/WalletPageIcons'
import s from './styles.module.scss'
import { Checkbox } from '@App/ui/crypto_exchange/desktop/components/controls/Checkbox'
import cn from 'clsx'
import { ImpactIndicator } from './components/ImpactIndicator'

type ImpactTypes = 'low' | 'medium' | 'high' | 'none'

export const IMPACT_OPTIONS: {
  name: string
  value: ImpactTypes
}[] = [
  { name: 'Low', value: 'low' },
  { name: 'Medium', value: 'medium' },
  { name: 'High', value: 'high' },
  { name: 'None', value: 'none' },
]

export const ImpactFilter = ({ value, setFilter }: { value: string[]; setFilter: (val: string) => void }) => {
  return (
    <div className={s.container}>
      <div className={s.title}>Impact</div>
      <ul className={s.options}>
        <li key={'all-impacts'} className={s.option}>
          <ListTaskIcon className={cn(s.icon, s.all)} /> <span className={s.name}>All</span>
          <Checkbox name={'all-impacts'} checked={value.some((v) => v === 'all')} onClick={() => setFilter('all')} />
        </li>
        {IMPACT_OPTIONS.map((impact) => (
          <li key={impact.value} className={s.option}>
            <ImpactIndicator level={impact.value} />
            <span className={s.name}>{impact.name}</span>
            <Checkbox
              name={impact.value}
              checked={value.some((v) => v === impact.value)}
              onClick={() => setFilter(impact.value)}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
